<template>
  <div id="app" :style="cssVars">

    <div class="d-flex partidos-slider" id="slider-partidos" :style="{ 'background-color': bgcolor }"> <!-- bgcolor -->

      <div class="selects-container">

        <div class="flex-partidos-slider__select-fecha" v-if=" ! loading_fechas && initial_done && ismultileague" v-cloak>
          <div class="select-wrapper">
            <multiselect :allow-empty="false" track-by="value" label="label" :searchable="false" v-model="current_league" :options="leagues" @input="changeLeague($event)" :show-labels="false">
              <template slot="noResult">
              </template>
            </multiselect>
          </div>
        </div>

        <div class="flex-partidos-slider__select-fecha" v-if=" ! loading_fechas && initial_done" v-cloak>
          <div class="select-wrapper">
            <multiselect :allow-empty="false" track-by="value" label="label" :searchable="false" v-model="current_fecha" :options="fechas" @select="getPartidos" :show-labels="false">
              <template slot="noResult">
              </template>
            </multiselect>
          </div>
        </div>

      </div>

      <div class="cssload-container" v-show="loading_partidos || ! initial_done">
        <div class="lds-dual-ring"></div>
      </div>

      <div class="partidos-slider__partidos-container" v-cloak id="partidos" v-show="! loading_partidos">

        <splide :options="SplideOptions" :slides="partidos" class="partidos-slider__partidos-list d-flex splide">
          <splide-slide class="partidos-slider__partido" v-for="partido in partidos" :key="partido.matchId" :style="{ 'border-left-color': sepbgcolor,  'border-right-color': sepbgcolor}">
            <div class="partido-container">
              <div class="d-flex partido-resultado">

                <div class="partido-equipos">
                  <div class="d-flex equipo-single pb-1">
                    <div class="equipo-escudo" v-bind:style="{ backgroundImage: 'url(' + partido.competitors[0].logo + ')' }">
                    </div>
                    <div class="d-flex equipo-nombre">{{ partido.competitors[0].teamNickname }}</div>

                  </div>
                  <div class="d-flex equipo-single">
                    <div class="equipo-escudo" v-bind:style="{ backgroundImage: 'url(' + partido.competitors[1].logo + ')' }">
                    </div>
                    <div class="d-flex equipo-nombre">{{ partido.competitors[1].teamNickname }}</div>
                  </div>
                </div>
                <div class="partido-marcador">
                  <div class="equipo-resultado" v-if="partido.matchStatus !== 'IN_PROGRESS'">{{ partido.competitors[0].scoreString.length ? partido.competitors[0].scoreString : '-' }}</div>
                  <div class="equipo-resultado erpt-11" v-if="partido.matchStatus !== 'IN_PROGRESS'">{{ partido.competitors[1].scoreString.length ? partido.competitors[1].scoreString: '-' }}</div>
                  <div class="equipo-resultado" v-if="partido.matchStatus === 'IN_PROGRESS'">{{ partido.live && partido.live.scores ? partido.live.scores['1'] : '-' }}</div>
                  <div class="equipo-resultado erpt-11" v-if="partido.matchStatus === 'IN_PROGRESS'">{{ partido.live && partido.live.scores ? partido.live.scores['2'] : '-' }}</div>

                </div>
              </div>
              <!-- class="slider-partido__estado" -->
              <div class="slider-partido__estado" :class="partido.matchStatus === 'IN_PROGRESS' || partido.entretiempo ? 'slider-partido__estado__live' : 'slider-partido__estado'" :style="{ 'background-color': sbgcolor, 'color': 'black'}">
                <span v-if="partido.matchStatus === 'COMPLETE'">FINAL</span>

                <span v-if="partido.matchStatus === 'POSTPONED'">{{ lang == 'es' ? 'POSPUESTO': 'POSPONED'}}</span>
                <span v-if="partido.matchStatus === 'CANCELLED'">{{ lang == 'es' ? 'CANCELADO': 'CANCELLED'}}</span>
                <span v-if="partido.matchStatus === 'ABANDONED'">{{ lang == 'es' ? 'ABANDONADO': 'ABANDONED'}}</span>
                <span v-if="partido.matchStatus === 'DELAYED'">{{ lang == 'es' ? 'RETRASADO': 'DELAYED'}}</span>

                <span v-if="partido.matchStatus === 'SCHEDULED'">{{ partido.fecha_corta }}</span>
                <span v-if="partido.matchStatus ==='IN_PROGRESS' && partido.live && partido.live.periodType !=='OVERTIME'">Q {{ partido.live.period}} <span> / {{ partido.tiempo_minutos }}</span></span>
                <span v-if="partido.matchStatus ==='IN_PROGRESS' && partido.live && partido.live.periodType === 'OVERTIME'">OT {{ partido.live.period}} <span> / {{ partido.tiempo_minutos }}</span></span>

                <!--
                <span v-if="partido.entretiempo">{{ lang == 'es' ? 'ET' : 'HT'}}</span>
                -->
              </div>

              <div class="partido-hover" v-show="partido.matchStatus === 'SCHEDULED'">
                <div class="text-center">
                  <a v-bind:href="previewurl+partido.matchId" class="d-flex flex-column align-items-center">
                    <img class="ph-img" src="./assets/img/iconos/stats_icon_2.svg" width="25" />
                    <span>{{ lang == 'es' ? 'PREVIA' : 'PREVIEW'}}</span>
                  </a>
                </div>
              </div>

              <div class="partido-hover" v-show="partido.matchStatus === 'IN_PROGRESS'">
                <div class="text-center">
                  <a v-bind:href="liveurl+partido.matchId" class="d-flex flex-column align-items-center">
                    <img class="ph-img" src="./assets/img/iconos/watch_icon_2.png" width="25" />
                    <span>{{ lang == 'es' ? 'VIVO' : 'LIVE'}}</span>
                  </a>
                </div>
              </div>

              <div class="partido-hover" v-show="partido.matchStatus === 'COMPLETE'">
                <div class="text-center">
                  <a v-bind:href="liveurl+partido.matchId" class="d-flex flex-column align-items-center ml-1">
                    <img class="ph-img" src="./assets/img/iconos/stats_icon_2.svg" width="25"/>
                    <span>BOX SCORE</span>
                  </a>
                </div>
              </div>
            </div>
          </splide-slide>
        </splide>
      </div>
    </div>

  </div>
</template>

<script>
    import moment from 'moment-timezone';
    import Multiselect from 'vue-multiselect';
    import { Splide, SplideSlide } from '@splidejs/vue-splide'; /* createSlides */
    var api_base_url = '';
    const axios = require('axios').default;

    export default {

        components: { Multiselect, Splide, SplideSlide }, /* Splide */
        delimiters: ['<%', '%>'],
        props: {lang: String, selbgcolor: String, bgcolor: String, sepbgcolor: String, multiselectbcolor: String, pcontainercolor: String, sbgcolor: String, scolor: String, arrowcolor: String, hbgcolor: String, lbgcolor: String, lcolor: String, league: String, leaguename: String, previewurl: String, liveurl: String, multileague: Boolean, sleaguename: String, sleagueslug: String, hoverbgcolor: String},
        data: function () {
            return {
                fechas: [],
                ismultileague: false,
                current_fecha: null,
                current_league: null,
                leagues: [],
                loading_fechas: true,
                loading_partidos: true,
                partidos: [],
                initial_done: false,
                interval: null,
                SplideOptions: {
                    type   : 'slide',
                    'arrowPath': 'M9,19.4l-9,13.5v-27L9,19.4z',
                    perPage: 1,
                    perMove: 1,
                    width: '100%',
                    autoWidth: true,
                    pagination: false,
                    rewind: false,
                },
            }
        },
        filters: {
            prefix_partido: function (value) {
                return '/partido/'+value+'/';
            }
        },

        mounted: function () {
            this.init();
        },
        computed: {
            cssVars() {
                return {
                    '--selbg-color': this.selbgcolor,
                    '--bg-color': this.bgcolor,
                    '--fg-color': this.scolor,
                    '--arrow-color': this.arrowcolor,
                    '--multiselectbcolor': this.multiselectbcolor,
                    '--pcontainercolor': this.pcontainercolor,
                    '--sbg-color': this.sbgcolor,
                    '--hbg-color': this.hbgcolor,
                    '--hoverbg-color': this.hoverbgcolor,
                    '--lbg-color': this.lbgcolor,
                    '--l-color': this.lcolor,
                    '--sepbg-color': this.sepbgcolor
                }
            }
        },
        methods: {
            handleInit(event, slick) {
                console.log('handleInit', event, slick);
            },
            changeLeague(event){
//                console.log('changeleague');
                console.log(event);
//                console.log(this.current_league.value);
                this.loading_partidos = true;
                this.loading_fechas = true;
                api_base_url = 'https://gapi.pixeles.club/ligas/' + this.current_league.value + '/api/';
//              api_base_url = 'http://127.0.0.1:8000/ligas/' + this.current_league.value + '/api/';

                axios.get(api_base_url+'roundsbqbyteam?lang='+this.lang).then((response) => {
                    this.fechas = response.data;
                    this.fechas.forEach((f)=>{
                        if(f.default){
                            this.current_fecha = f;
                        }
                    });

                    /* Si no tengo default pongo como default la 1ra */
                    if(!this.current_fecha){
                        this.current_fecha = this.fechas[0];
                    }
                    this.loading_fechas = false;
                    this.getPartidos();
                }).catch( error => { console.log(error); });
            },
            init(){
//                console.log(this.multileague);
//                console.log(this.league);
                if(this.multileague==='true'){
                    this.ismultileague = true;
//                    console.log('multileague');
                    api_base_url = 'https://gapi.pixeles.club/ligas/' + this.league + '/api/';
//                  api_base_url = 'http://127.0.0.1:8000/ligas/' + this.league + '/api/';

                    this.leagues.push({
                        value: this.league,
                        label: this.leaguename,
                        default: true
                    });
                    this.current_league = this.leagues[0];
                    this.leagues.push({
                        value: this.sleagueslug,
                        label: this.sleaguename,
                        default: false
                    });
                }else{
                    api_base_url = 'https://gapi.pixeles.club/ligas/' + this.league + '/api/';
//                  api_base_url = 'http://127.0.0.1:8000/ligas/' + this.league + '/api/';

                }

                axios.get(api_base_url+'roundsbqbyteam?lang='+this.lang).then((response) => {

                    this.fechas = response.data;
                    this.fechas.forEach((f)=>{
                        if(f.default){
                            this.current_fecha = f;
                        }
                    });

                    /* Si no tengo default pongo como default la 1ra */
                    if(!this.current_fecha){
                        this.current_fecha = this.fechas[0];
                    }
                    this.loading_fechas = false;
                    this.getPartidos();
                }).catch( error => { console.log(error); });
            },

            getPartidos: function(fecha,refresh, justLive=false){
                var f =fecha;
                if(fecha){
                    f = fecha;
                }else{
                    f = this.current_fecha;
                }
                if(!refresh) {
                    this.loading_partidos = true;
                }
                if(justLive) {
                  axios.get(api_base_url + 'bq/matches_livestream'+'?lang=' + this.lang, {responseType: "json"}).then((res) => {
                    let resdata = res.data;
                    if(resdata.length){
                        this.partidos.forEach((m, mindex) => {
                          resdata.forEach((p) => {
                            if (p.matchTimeUTC) {
                              try {
                                var formattedTime = moment.tz(p.matchTimeUTC, 'UTC').local().format('h:mm A');
                                var formattedDate = moment.tz(p.matchTimeUTC, 'UTC').local().format('DD.MM');
                                p.fecha_corta = formattedDate + ' / ' + formattedTime;
                                p.tiempo_minutos = p.live.clock.slice(0, 5);
                              } catch (error) {
                                console.error(error);
                              }
                            }
                            if (p.matchId === m.matchId) {
                              this.partidos.splice(mindex, 1, p);
                            }
                          });
                        });
                    } else {
                      window.clearInterval(this.interval);
                      this.getPartidos(null, false, false);
                    }
                  }).catch(error => {
                    console.log(error);
                  });

                } else {
                  axios.get(api_base_url + 'roundsbqbyteam/' + f.value + '?lang=' + this.lang).then((response) => {
                    this.partidos = response.data;
//                    console.log(this.partidos);

                    var tengo_vivo = false;
                    this.partidos.forEach((p) => {
                      if (p.matchStatus == 'IN_PROGRESS') {
                        tengo_vivo = true;
                        if (p.live && p.live.status) {
                          if (p.live.status == 'periodbreak' || p.live.status == 'oncourt' && p.live.periodStatus == 'ended') {
                            p.entretiempo = true;
                          }
                          p.tiempo_minutos = p.live.clock.slice(0, 5);
                        }
                      }

                      if (p.matchTimeUTC) {
                        try {
                          var formattedTime = moment.tz(p.matchTimeUTC, 'UTC').local().format('h:mm A');
                          var formattedDate = moment.tz(p.matchTimeUTC, 'UTC').local().format('DD.MM');
                          p.fecha_corta = formattedDate + ' / ' + formattedTime;
                        } catch (error) {
                          console.error(error);
                        }

                      }
                    });

                    if (!this.initial_done) {
                      if (tengo_vivo && !refresh) {
                        this.interval = setInterval(function () {
                          this.getPartidos(null, true, true);
                        }.bind(this), 30000);
                      }
                    } else if (!tengo_vivo && refresh) {
                      window.clearInterval(this.interval);
                    }

                    if (!refresh) {
                      this.loading_partidos = false;
                      if (!this.initial_done) {
                        this.initial_done = true;
                      }
                    }
                  }).catch(error => {
                    console.log(error);
                  });
                }
            }
        }
    }
</script>
<style src="@splidejs/splide/dist/css/splide-core.min.css"></style>
<style src="@splidejs/splide/dist/css/splide.min.css"></style>

<style type="text/scss" lang="scss">
    @import "./assets/css/bootstrap.min.css";
    @import "./assets/css/slick.css";
    @import "./assets/css/slick-theme.css";
    @import "./assets/css/vue-multiselect.min.css";
    @import "./assets/css/main.module.css";
    :root {
      padding: 20px;
    }
      .at-btn + .at-btn {
        margin-left: 0.5rem;
      }

      .multiselect {
        background-color: var(--multiselectbcolor) !important;
      }

      .partido-container {
        background-color: var(--pcontainercolor) !important;
      }

      .multiselect__option {
        background-color: var(--selbg-color) !important;
        color: black;
      }

      .multiselect__option--highlight,
      .multiselect__option--selected.multiselect__option--highlight {
        background: var(--sbg-color) !important;
        border: none;
      }

      .multiselect__option--selected {
        background: var(--sbg-color) !important;
        color: black !important;
      }

      .partidos-slider__partidos-list .partidos-slider__partido:hover .partido-container {
        background: var(--hbg-color) !important;
      }

      .partidos-slider__partidos-list .partidos-slider__partido .partido-container .slider-partido__estado__live {
        background: transparent !important;
        color: #f24345 !important;
        font-weight: bold !important;
        /*
        background: var(--lbg-color) !important;
        color: var(--l-color) !important;
        */
      }

      .partidos-slider__partido {
        border-right-color: #e5e3e3 !important;
        border-left-color: #e5e3e3 !important;
        border-top-color: var(--sepbg-color) !important;

      }

      .partido-hover {
        /*
        background-color: var(--hoverbg-color) !important;
        */
      }

      #partidos {
        display: flex;
      }
      .carousel-nav {
        height: 100%;
        border: none;
        background: none;
      }

    .splide--draggable > .splide__track > .splide__list > .splide__slide {
      max-width: 230px;
    }
    .splide__arrow{position:absolute;z-index:1;top:50%;transform:translateY(-50%);border:none;padding:0;background:transparent}.splide__arrow svg{width:2.5em;height:2.5em;fill:#20b2aa;transition:fill .2s linear}.splide__arrow:hover{cursor:pointer}.splide__arrow:hover svg{fill:#57e1d9}.splide__arrow:focus{outline:none}.splide__arrow--prev{left:1em}.splide__arrow--prev svg{transform:scaleX(-1)}.splide__arrow--next{right:1em}.splide__slider>.splide__arrows .splide__arrow--prev{left:-2.5em}.splide__slider>.splide__arrows .splide__arrow--next{right:-2.5em}
    .splide__arrow--prev {
      left: -2.5em;
    }
    .splide__arrow--next {
      right: -2.5em;
    }
    .splide__arrow svg {
      fill: var(--arrow-color);
    }
    .splide__arrow:hover svg {
      fill: #ffffff;
    }
    .multiselect {
      border: 1px solid var(--multiselectbcolor) !important;
      margin-bottom: 5px !important;
    }
    /* Para costarica especificamente */
    .partidos-slider__partidos-list .partidos-slider__partido .partido-container {
/*
      background: #002D61 !important;
      padding: 5px 10px;
      padding-bottom: 5px;
      */
    }
    .partido-resultado {
      justify-content: left !important;
    }
    .partidos-slider__partidos-list .partidos-slider__partido .partido-container .partido-equipos .equipo-single .equipo-nombre {
      align-items: center !important;
      font-size: 11px !important;
      padding: 0 5px !important;
      text-transform: uppercase !important;
      font-weight: bold;
      line-height: 14px;
    }

</style>
